import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class RuntimeServer  {
    _originalTypeClassName = "zAppDevManager.BO.RuntimeServer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
RuntimeServer.translate = translateService;
}
this.Id = null;
this.Code = null;
this.ProxyURL = null;
this.ControlURL = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
ProxyURL:any;
ControlURL:any;
Environment:any;
static setEnvironment = ($this, value) => {
var oldValue = $this.Environment;
$this.Environment = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}